import config from "client/config"

/** this is the actual product version used internally to track builds and releases */
const productVersion = require('../package.json').version;

export default {
	...config,
	/** this is the product version displayed to the user in the UI */
	productVersionFaceValue: "2.40 U1",
	webViewVersion: productVersion,
}